// extracted by mini-css-extract-plugin
module.exports = {"name":"_1SA7ZKe5LlBMD8dxL6DbCj","OwnerName":"_1dQI6hwETG39u58UliS2OQ","Elon":"_1Jg6zmqXk1LXK3A53qeLd5","Musk":"_3vtEL0dQu-hwhq6ja6XkuG","who":"_1NShAzXANHVw6tOUfRBidq"};